export default __webpack_public_path__ + "static/brands-lead-bg--mobile@1x-35d72aadd3dca389a27af3b38a05b143.jpg";